import { Box, List } from '@chakra-ui/react';

import { CommentItem } from './comment-item';
import { CommentsItemizedContentAddComment } from './comments-itemized-content-add-comment';
import { Kitchen } from '@rta/rta-blueprint-library';
import { useEffect } from 'react';
import { selectCommentAdded, useAppSelector } from '@state';

export type CommentsContentProps = {
	kitchenData: Kitchen;
  }

export const CommentsItemizedContent = ({ kitchenData }: CommentsContentProps) => {
	const commentAdded = useAppSelector(selectCommentAdded);

	const kitchenComments = kitchenData?.notes?.children ?? [];
	// console.log('Kitchen comments:', kitchenComments);

	useEffect(() => {
		if (commentAdded) {
			// console.log('Comment added, refreshing UI');
		}
	}, [commentAdded, kitchenComments]);

	return (
		<Box pl="10px" pr="10px" overflowY={'scroll'}>
			<List spacing={2}>
				{kitchenComments.map((comment) => (
					<CommentItem key={comment.id} data={comment}/>
				))}
			</List>
			<CommentsItemizedContentAddComment notes={kitchenData?.notes}/>
		</Box>
	);
};
